class NcmController extends AbstractController
  @$inject = ['$injector', '$scope', 'ncmService', 'pathService', 'decretoService']

  constructor: ($injector, scope, @ncmService, pathService, @decretoService) ->
    super($injector)

    @exibirModelo = false
    @listOfType = [
      {id: 'TIPI', nome:'TIPI'}
      {id: 'TEC', nome:'TEC'}
    ]

    @filtro =
      ncm: ''
      descricao: ''

    @pagination =
      perPage: 1

    @tabController = scope.tabController
    @loadingTracker = @promiseTracker()

    @url = "#{pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/ncm/"

    @modalNcm = @openPopup("#{@url}modal.html", 'ncmModalController as ctrl')
    @modalImportNcm = @openPopup("#{@url}importar.html", 'ncmImportModalController as ctrl')

    @loadNcms()

  loadNcms: (page = 1) ->
    filtro =
      page: page
      ncm: @filtro.ncm
      descricao: @filtro.descricao
      tipo: @filtro.tipo if @filtro.tipo
    @loadingTracker.addPromise(@ncmService.getList(filtro,
      (data) =>
        if data.success
          data = data.data
          firstItem = ((page - 1) * data.perPage)
          lastItem = firstItem + data.perPage

          @pagination =
            page: page
            total: data.total_pages
            perPage: 1
            firstItem: firstItem + 1
            lastItem: if data.total_items > lastItem then lastItem else data.total_items
            totalItems: data.total_items
          @listOfNcm = data.items
      )
    )
    @loadingTracker.addPromise @decretoService.getList( (data) =>
      @decreto = data[0]
    )

  abrirModal: (ncm, page = 1) ->
    @modalNcm({
        ncm: =>
          ncm
      }, (result) =>
      @loadNcms(page) if result.ok
    )

  abrirDecretos: ->
    @tabController.addTab
      id: "ncm-decretos"
      label: "Decretos"
      closable: true
      url: "#{@url}decretos"

  adicionar: ->
    @abrirModal({})

  editar: (ncm) ->
    @abrirModal(ncm, @pagination.page)

  importar: () ->
    @modalImportNcm({}, (result) =>
      @loadNcms(@pagination.page) if result.ok
    )

  remover: (ncm) ->
    @Confirm.warning("Atenção!",
      "Deseja realmente remover o NCM <strong>#{ncm.classificacao}</strong>? Essa ação não poderá ser desfeita.", {
        'Sim': =>
          @ncmService.delete(ncm.id, (data)=>
            if data.success
              @Alert.success("NCM <strong>#{ncm.classificacao}</strong> removido com sucesso.", "Sucesso!")
              @loadNcms()
            else
              messages =
                ncm_importado: 'Ncm foi importado e não pode ser excluido.'
              retorno = ''
              data.message.each((message)->
                retorno += messages[message] + '<br>'
              )
              @Alert.warning(retorno, "Não é possível!", false)
          )
        'Não': null
      })

  baixar: ->
    cbk.download '/api/eficiencia-fiscal/ncm.csv'


angular.module("eficienciaFiscalModule").controller('ncmController', NcmController)


class NcmModalController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'ncmService', 'ncm']

  constructor: ($injector, @modalInstance, @ncmService, ncm) ->
    super($injector)
    @listOfType = [
      {id: 'TIPI', nome:'TIPI'}
      {id: 'TEC', nome:'TEC'}
    ]

    @listOfTecOperacoes = [
      {id:'BK', nome: 'Bens de Capital'}
      {id:'BIT', nome: 'Bens de Informática e Telecomunicações'}
      {id:'TEC', nome: 'Tarifa Externa Comum'}
    ]
    @submitTracker = @promiseTracker()

    @ncm = angular.copy ncm

    @editando = ncm.id?

  salvar: (form, ncm) ->
    callback = (data) =>
      if(data.success)
        @Alert.success("NCM #{data.data.tipo} <strong>#{data.data.classificacao}</strong> #{if @editando then 'atualizado' else 'criado'} com sucesso.",
          "Sucesso!")
        @modalInstance.close(new Retorno(true))
      else
        messages =
          ncm_cadastrado: 'Código do NCM já cadastrado'
          ncm_alterado: 'Código do NCM não pode ser alterado'
          ncm_invalido: 'Código do NCM inválido'
        retorno = ''
        data.message.each((message)->
          retorno += messages[message] + '<br>'
        )
        @Alert.warning(retorno, "Atenção!", false)

    if form.$valid
      @submitTracker.addPromise(
        @ncmService.save(ncm, callback)
      )
angular.module("eficienciaFiscalModule").controller('ncmModalController', NcmModalController)


class NcmImportModalController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'FileUploader']

  constructor: ($injector, @modalInstance, FileUploader) ->
    super($injector)

    @uploader = new FileUploader(
      url: '/api/eficiencia-fiscal/ncm'
      headers: cbk.getHeaders()
      formData: []
    )

    @uploader.onCompleteItem = (fileItem, response, status, headers) =>
      @modalInstance.close(new Retorno(true))

  importar: ->
    @uploader.uploadAll()

angular.module("eficienciaFiscalModule").controller('ncmImportModalController', NcmImportModalController)